<div class="step-counter">
  Step {{ totalSteps }} of {{ totalSteps }}
</div>

<div>
  @if (hasUnverifiedOptions) {
    If you lose your phone or your verification method is unavailable, it is
    recommended that you set up a backup option to help you get into your account.
  } @else {
    Congratulations! You are all set up for Two Step Verification!
  }
</div>

@if (hasUnverifiedOptions) {
  <div class="add-another">
    <a id="btnChooseOption"
       href="./EnrollmentOptions">Add another verification method</a>
  </div>
}

<div class="buttons">
  <a mat-flat-button
     id="btnComplete"
     color="primary"
     href="./Finish">Complete</a>
</div>